import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { generateMethods } from '../index';
export const useGenerateMethods = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(generateMethods, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetPluginDescriptionList');
            setAction({
                type: 'success',
                message: 'Method generation for the plugin is successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
